export const DOMESTIC_CART_QUERY_KEY = 'domesticCart'

export const DOMESTIC_CART_DAYUSE_TIME_LINES_QUERY_KEY = 'domesticCartDayuseTimeLines'
